import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d5716f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ClientsListItem" }
const _hoisted_2 = { class: "flex items-start justify-between text-sm" }
const _hoisted_3 = { class: "flex flex-col items-start justify-start" }
const _hoisted_4 = { class: "text-base font-semibold" }
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "client ID:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "client secret:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "user ID:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "user email:", -1))
const _hoisted_10 = { class: "mt-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "scopes:", -1))
const _hoisted_12 = { class: "mt-3 select-none" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Дата создания:", -1))
const _hoisted_14 = { class: "select-none" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Дата обновления:", -1))
const _hoisted_16 = { class: "flex items-start" }
const _hoisted_17 = { class: "flex items-center justify-end mt-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-key mr-2" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, "(ID: " + _toDisplayString(_ctx.item.id) + ") " + _toDisplayString(_ctx.item.name), 1),
        _createElementVNode("span", _hoisted_5, [
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_ctx.item.id), 1)
        ]),
        _createElementVNode("span", null, [
          _hoisted_7,
          _createTextVNode(" " + _toDisplayString(_ctx.item.secret || 'Нет данных'), 1)
        ]),
        _createElementVNode("span", null, [
          _hoisted_8,
          _createTextVNode(" " + _toDisplayString(_ctx.item.user_id || 'Нет данных'), 1)
        ]),
        _createElementVNode("span", null, [
          _hoisted_9,
          _createTextVNode(" " + _toDisplayString(_ctx.item.user_email || 'Нет данных'), 1)
        ]),
        _createElementVNode("p", _hoisted_10, [
          _hoisted_11,
          _createTextVNode(" " + _toDisplayString(_ctx.item.scopes.map((scope) => scope.scope)), 1)
        ]),
        _createElementVNode("p", null, "redirect: " + _toDisplayString(_ctx.item.redirect), 1),
        _createElementVNode("p", _hoisted_12, [
          _hoisted_13,
          _createTextVNode(" " + _toDisplayString(_ctx.moment(_ctx.item.created_at).format('DD.MM.YYYY')), 1)
        ]),
        _createElementVNode("p", _hoisted_14, [
          _hoisted_15,
          _createTextVNode(" " + _toDisplayString(_ctx.moment(_ctx.item.updated_at).format('DD.MM.YYYY')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_cheap, {
          class: _normalizeClass(["small mr-2", { primary: _ctx.item.password_client }])
        }, {
          default: _withCtx(() => [
            _createTextVNode(" password client ")
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_cheap, {
          class: _normalizeClass(["small mr-2", { primary: _ctx.item.personal_access_client }])
        }, {
          default: _withCtx(() => [
            _createTextVNode(" personal_access_client ")
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_cheap, {
          class: _normalizeClass(["small mr-2", { primary: _ctx.item.service_client }])
        }, {
          default: _withCtx(() => [
            _createTextVNode(" service client ")
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_cheap, {
          class: _normalizeClass(["small", { primary: _ctx.item.revoked }])
        }, {
          default: _withCtx(() => [
            _createTextVNode("revoked")
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      (_ctx.item.personal_access_client)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 0,
            class: "primary small text mr-2",
            loading: _ctx.state.is_token_generating,
            onClick: _ctx.generateToken
          }, {
            default: _withCtx(() => [
              _hoisted_18,
              _createTextVNode(" Сгенерировать токен ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_the_button, {
        class: "primary small text mr-2",
        onClick: _ctx.emitUpdate
      }, {
        default: _withCtx(() => [
          _hoisted_19,
          _createTextVNode(" Редактировать ")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_the_button, {
        class: "red small text",
        onClick: _ctx.emitDelete
      }, {
        default: _withCtx(() => [
          _hoisted_20,
          _createTextVNode(" Удалить ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}